export default "__VITE_ASSET__a88c6fe3__"